import {hoistCmp, uses} from '@xh/hoist/core';
import {WorkflowLogModel} from './WorkflowLogModel';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {Icon} from '@xh/hoist/icon';
import {grid} from '@xh/hoist/cmp/grid';
import {toolbar, toolbarSeparator} from '@xh/hoist/desktop/cmp/toolbar';
import {button} from '@xh/hoist/desktop/cmp/button';
import {filler} from '@xh/hoist/cmp/layout';
import './WorkflowLog.scss';

export const executionLog = hoistCmp.factory<WorkflowLogModel>({
    model: uses(WorkflowLogModel),
    render({model}) {
        return panel({
            model: model.panelModel,
            omit: !model.isVisible,
            tbar: toolbar({
                className: 'workflow-log__toolbar',
                items: [
                    Icon.eye(),
                    'Execution log',
                    filler(),
                    button({
                        icon: Icon.refresh(),
                        intent: 'success',
                        tooltip: 'Refresh',
                        onClick: () => model.refresh()
                    }),
                    toolbarSeparator(),
                    button({
                        icon: model.panelModel.isModal ? Icon.collapse() : Icon.expand(),
                        onClick: () => model.panelModel.toggleIsModal()
                    }),
                    button({icon: Icon.x(), onClick: () => model.close()})
                ]
            }),
            item: grid({model: model.executionLogGrid, className: 'workflow-log__grid'}),
            mask: model.apiTask
        });
    }
});
